import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { Button } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resolvePageKeyFromPathname } from "../analytics/pageRegistry";
import { trackProductAccessDenied } from "../analytics/product";
import {
  buildProductBaseFromRegistry,
  useProductAnalyticsContext,
} from "../hooks/useProductAnalyticsContext";
import { PendingApprovalBlockedPage } from "gsintegrations";
import { ROUTE } from "../constants/routes";

interface PendingApprovalBlockedProps {
  title?: string;
  description?: string;
}

const PendingApprovalBlocked: React.FC<PendingApprovalBlockedProps> = ({
  title,
  description,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useProductAnalyticsContext();

  useEffect(() => {
    const registryEntry = resolvePageKeyFromPathname(location.pathname);
    trackProductAccessDenied(
      registryEntry
        ? buildProductBaseFromRegistry(registryEntry, context, location)
        : {
            pageKey: "pending_approval_blocked",
            routePath: location.pathname,
            sourcePage: "PendingApprovalBlocked",
            productArea: "system",
            activeProfileType: context.activeProfileType,
            terreiroId: context.terreiroId,
            mediumId: context.mediumId,
          },
      {
        reasonCode: "pending_approval",
      },
    );
  }, [context, location]);

  const handleGoBackWithFallback = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(ROUTE.APP_HOME, { replace: true });
  };

  const actions = useMemo(
    () => (
      <>
        <Button
          variant="outlined"
          startIcon={<HomeOutlinedIcon />}
          onClick={() => navigate(ROUTE.APP_HOME)}
        >
          Ir para Home
        </Button>

        <Button
          variant="outlined"
          startIcon={<LoginOutlinedIcon />}
          onClick={() => navigate(ROUTE.TERREIRO_JOIN)}
        >
          Ver solicitações de ingresso
        </Button>
      </>
    ),
    [navigate]
  );

  return (
    <PendingApprovalBlockedPage
      title={title}
      description={description}
      countdownSeconds={10}
      onGoBackNow={handleGoBackWithFallback}
      onCountdownComplete={handleGoBackWithFallback}
      actions={actions}
    />
  );
};

export default PendingApprovalBlocked;
